import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { Box, Collapse, Tooltip } from '@mui/material';
import React from 'react';
import { InvestmentAllocation } from '../../models/InvestmentEntity';
import { StyledIconButton } from '../styles/StyledButtons';
import { StyledCard, StyledCardContent, StyledHeading, StyledTypography } from '../styles/styles';
import { EntityManagementAllocationCard } from './EntityManagementAllocationCard';
import { getOpportunityId } from './entityManagementUtils';

interface EntityManagementAllocationsSectionProps {
  allocations: InvestmentAllocation[];
  expanded: boolean;
  onToggleExpanded: () => void;
}

export const EntityManagementAllocationsSection: React.FC<
  EntityManagementAllocationsSectionProps
> = ({ allocations, expanded, onToggleExpanded }) => (
  <StyledCard tone="default" sx={{ mb: 3 }}>
    <StyledCardContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <StyledHeading tone="default" headerVariant="heading2">
          Investments & Allocations
        </StyledHeading>
        <Tooltip title={expanded ? 'Hide Allocations' : 'Show Allocations'}>
          <StyledIconButton size="small" onClick={onToggleExpanded}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </StyledIconButton>
        </Tooltip>
      </Box>

      <Collapse in={expanded}>
        {allocations.length > 0 ? (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
            {allocations.map((allocation) => {
              const opportunityId = getOpportunityId(allocation) || 'unknown';

              return (
                <EntityManagementAllocationCard
                  key={`${allocation.investorId}-${allocation.investmentEntityId}-${opportunityId}`}
                  allocation={allocation}
                />
              );
            })}
          </Box>
        ) : (
          <StyledTypography sx={{ py: 2, textAlign: 'center', color: 'text.secondary' }}>
            No allocations found for this entity
          </StyledTypography>
        )}
      </Collapse>
    </StyledCardContent>
  </StyledCard>
);
